var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.LandingSignUpSection
  }, [_c('span', {
    class: [_vm.$style.gradientCircle, _vm.$style.gradientCircle3]
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.inner
  }, [_c('div', {
    class: _vm.$style.top
  }, [_c('div', {
    class: _vm.$style.left
  }, [_c('div', {
    class: [_vm.$style.title, _vm.$style.gradientText]
  }, [_c('div', [_vm._v("\n              Зарегистрируйтесь\n            ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    class: [_vm.$style.card, _vm.$style.cardFirst]
  }, [_c('div', {
    class: _vm.$style.cardNumber
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    class: _vm.$style.cardTitle
  }, [_c('div', [_vm._v("Перейдите")]), _vm._v("\n              по ссылке\n            ")]), _vm._v(" "), _c('div', [_c(_setup.SButton, {
    attrs: {
      "n-link": "",
      "href": "/account/agents/registration",
      "rounded": "",
      "theme": "primary",
      "size": "x-large"
    }
  }, [_vm._v("\n                Зарегистрироваться\n              ")])], 1)])]), _vm._v(" "), _c('div', {
    class: _vm.$style.right
  }, [_c('div', {
    class: [_vm.$style.card, _vm.$style.cardSecond]
  }, [_c('div', {
    class: _vm.$style.cardNumber
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    class: _vm.$style.cardTitle
  }, [_vm._v("\n              Пройдите регистрацию\n            ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.cardDescription
  }, [_vm._v("\n              Зарегистрируйте ваше агентство, если его еще нет в системе\n            ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.cardImg
  }, [_c(_setup.ResponsivePicture, {
    attrs: {
      "src-mobile": _setup.signUpImg1,
      "src-desktop": _setup.signUpImg1x2
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    class: _vm.$style.center
  }, [_c('div', {
    class: [_vm.$style.card, _vm.$style.cardThird]
  }, [_c('div', {
    class: _vm.$style.cardNumber
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    class: _vm.$style.cardTitle
  }, [_vm._v("\n            Зарегистрируйте агента\n          ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.cardDescription
  }, [_vm._v("\n            Укажите ИНН вашего агентства\n          ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.cardImg
  }, [_c(_setup.ResponsivePicture, {
    attrs: {
      "src-mobile": _setup.signUpImg2,
      "src-desktop": _setup.signUpImg2x2
    }
  })], 1)])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', [_c('span', [_vm._v("\n                в пару кликов\n              ")])]);
}];
export { render, staticRenderFns };